import { Check, X } from "lucide-react";

import { cn } from "@/lib/utils";
import type { ScorecardAssertionSummary } from "@/queries/smart-tables/scorecard";

interface ScorecardAssertionResultsProps {
  assertions: ScorecardAssertionSummary[];
  className?: string;
}

const ScorecardAssertionResults = ({ assertions, className }: ScorecardAssertionResultsProps) => {
  if (assertions.length === 0) {
    return null;
  }

  return (
    <div className={cn("space-y-1", className)}>
      {assertions.map(assertion => {
        const passed = assertion.pass_count > 0 && assertion.fail_count === 0;
        const Icon = passed ? Check : X;
        let statusTitle = "Failed";
        if (passed) {
          statusTitle = "Passed";
        } else if (assertion.total_count > 1) {
          statusTitle = `${assertion.fail_count} of ${assertion.total_count} rows failed`;
        }

        return (
          <div
            key={assertion.assertion}
            className="flex min-w-0 items-start gap-1.5 rounded-md px-1.5 py-1 text-xs leading-4"
          >
            <span
              className={cn(
                "mt-0.5 flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full",
                passed ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700",
              )}
              title={statusTitle}
              aria-label={statusTitle}
            >
              <Icon className="h-2.5 w-2.5 stroke-[2.5]" aria-hidden="true" />
            </span>
            <span
              className="line-clamp-2 min-w-0 break-words text-foreground/85"
              title={assertion.assertion}
            >
              {assertion.assertion}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ScorecardAssertionResults;
